// @flow
import React, { Component } from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';
import config from '../../config';
import { HyperText } from '../../components/common';
import { SafeAreaView } from 'react-native-safe-area-context';

class About extends Component<{}> {
  render() {
    const url = config.STATIC_FILE_URL.replace('{fileName}', config.STATIC_FILE_NAME.privacyPolicy);
    const style = getStyle();
    return (
      <SafeAreaView style={style.container} edges={['bottom', 'left', 'right']}>
      <ScrollView >
        <Text style={[style.bold, style.title]}>{I18n.t('about.appEditor.genericInfo.title')}</Text>
        <Text>{I18n.t('about.appEditor.genericInfo.text')}</Text>
        <Text style={style.bold}>{I18n.t('about.appEditor.genericInfo.location.subtitle')}</Text>
        <Text>{I18n.t('about.appEditor.genericInfo.location.text')}</Text>
        <Text style={[style.bold, style.title]}>{I18n.t('about.appEditor.host.title')}</Text>
        <Text>{I18n.t('about.appEditor.host.text')}</Text>
        <Text style={[style.bold, style.title]}>{I18n.t('about.appEditor.owner.title')}</Text>
        <Text>{I18n.t('about.appEditor.owner.text')}</Text>
        <Text style={[style.bold, style.title]}>{I18n.t('about.appEditor.privacy.title')}</Text>
        <Text>
          <Text>{I18n.t('about.appEditor.privacy.textPart1')}</Text>
          <HyperText style={[style.bold, style.underline]} url={url}>
            {I18n.t('about.appEditor.privacy.link')}
          </HyperText>
          <Text>{I18n.t('about.appEditor.privacy.textPart2')}</Text>
        </Text>
      </ScrollView>
      </SafeAreaView>
    );
  }
}

const getStyle = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.backgroundColor,
      margin: 13,
    },
    bold: {
      fontWeight: 'bold',
    },
    underline: {
      textDecorationLine: 'underline',
    },
    title: {
      fontSize: 16,
    },
  });

export default About;
